import * as THREE from 'three';
import Experience from "../Experience";

export default class Skyer {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;

        this.multi = 100

        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('skyer');
        }
        this.setGeometry();
        this.setTextures();
        this.setMaterial();
        this.setMesh();
    }

    setGeometry() {
        let cloudSize = Math.floor(Math.random() * (6000 - 3000 + 1) + 3000) *  this.multi;
        let cloudSize2 = Math.floor(Math.random() * (6000 - 3000 + 1) + 3000) * this.multi;
        this.cloudSize = cloudSize;
        this.cloudSize2 = cloudSize2;
        this.geometry = new THREE.PlaneGeometry(this.cloudSize, this.cloudSize2);
    }

    setTextures() {
        this.textures = {};

        this.textures.color = this.resources.items.cloudTextue;
        this.textures.color.colorSpace = THREE.SRGBColorSpace;
    }

    setMaterial() {
        this.material = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            map: this.textures.color,
            side: THREE.DoubleSide,
            transparent: true,
            alphaTest: 0.001,
            depthWrite: false,
        });
    }

    setMesh() {
        this.spheres = [];
        for (let i = 0; i < 100; i++) {
            this.mesh = new THREE.Mesh(this.geometry, this.material);
            this.mesh.rotation.x = Math.PI * 0.5;
            this.mesh.rotation.z = Math.random() * Math.PI;

            // Tilfeldig posisjon for skyene
            this.mesh.position.x = Math.random() * 40000 - 20000;
            this.mesh.position.y = Math.random() * 2000 + 500; // Ulike høyder
            this.mesh.position.z = Math.random() * 40000 - 20000;

            // Legg til egendefinert "hastighet" som en del av skyobjektet
            this.mesh.userData.speed = Math.random() * 20 + 10; // Ulike hastigheter

            this.mesh.receiveShadow = true;
            this.scene.add(this.mesh);

            this.spheres.push(this.mesh);
        }
    }

    // Oppdater skyenes posisjon for å lage en evig loop med ulike hastigheter
    update() {
        this.spheres.forEach((cloud) => {
            // Flytt skyen langs x-aksen basert på dens spesifikke hastighet
            cloud.position.x -= cloud.userData.speed * 0.1;

            // Hvis skyen er utenfor synsrekkevidde, tilbakestill posisjonen
            if (cloud.position.x < -20000) {
                cloud.position.x = 20000;
                cloud.position.z = Math.random() * 40000 - 20000; // Tilfeldig z for variasjon
                cloud.position.y = Math.random() * 2000 + 500; // Tilfeldig høyde
            }
        });
    }
}